import { createSelector } from 'reselect';

import { Field } from 'utils/types/shared/enums';
import {
  makeSelectExpectedDailyDepositVolume,
  makeSelectExpectedDailyDepositVolumeMeta,
  makeSelectExpectedDepositOperationsMonthly,
  makeSelectExpectedDepositOperationsMonthlyMeta,
  makeSelectMaxDepositPerTransaction,
  makeSelectMaxDepositPerTransactionMeta,
  makeSelectPlannedMonthlyDepositVolumeUSD,
  makeSelectPlannedMonthlyDepositVolumeUSDMeta,
  makeSelectPlannedMonthlyWithdrawalVolumeUSD,
  makeSelectPlannedMonthlyWithdrawalVolumeUSDMeta,
  makeSelectPrimaryPurpose,
  makeSelectPrimaryPurposeDetailed,
  makeSelectPrimaryPurposeDetailedMeta,
  makeSelectPrimaryPurposeMeta,
  makeSelectWithdrawalAccountCountries,
  makeSelectWithdrawalAccountCountriesMeta,
} from './accountActivity';

export const makeSelectAccountActivityBlockData = () =>
  createSelector(
    [
      makeSelectPrimaryPurpose(),
      makeSelectPrimaryPurposeDetailed(),
      makeSelectPlannedMonthlyDepositVolumeUSD(),
      makeSelectPlannedMonthlyWithdrawalVolumeUSD(),
      makeSelectExpectedDepositOperationsMonthly(),
      makeSelectExpectedDailyDepositVolume(),
      makeSelectMaxDepositPerTransaction(),
      makeSelectWithdrawalAccountCountries(),
    ],
    (
      primaryPurpose,
      primaryPurposeDetailed,
      plannedMonthlyDepositVolumeUSD,
      plannedMonthlyWithdrawalVolumeUSD,
      expectedDepositOperationsMonthly,
      expectedDailyDepositVolume,
      maxDepositPerTransaction,
      withdrawalAccountCountries
    ) => ({
      accountActivity: {
        [Field.PRIMARY_PURPOSE_CORPORATE]: primaryPurpose,
        ...(primaryPurposeDetailed
          ? { [Field.PRIMARY_PURPOSE_DETAILED_CORPORATE]: primaryPurposeDetailed }
          : {}),
        [Field.PLANNED_MONTHLY_DEPOSIT_VOLUME_USD]: plannedMonthlyDepositVolumeUSD,
        [Field.PLANNED_MONTHLY_WITHDRAWAL_VOLUME_USD]: plannedMonthlyWithdrawalVolumeUSD,
        [Field.EXPECTED_DEPOSIT_OPERATIONS_MONTHLY]: expectedDepositOperationsMonthly,
        [Field.EXPECTED_DAILY_DEPOSIT_VOLUME]: expectedDailyDepositVolume,
        [Field.MAX_DEPOSIT_PER_TRANSACTION]: maxDepositPerTransaction,
        [Field.WITHDRAWAL_ACCOUNT_COUNTRIES]: withdrawalAccountCountries,
      },
    })
  );

export const makeSelectAccountActivityBlockMeta = () =>
  createSelector(
    [
      makeSelectPrimaryPurposeMeta(),
      makeSelectPrimaryPurposeDetailedMeta(),
      makeSelectPlannedMonthlyDepositVolumeUSDMeta(),
      makeSelectPlannedMonthlyWithdrawalVolumeUSDMeta(),
      makeSelectExpectedDepositOperationsMonthlyMeta(),
      makeSelectExpectedDailyDepositVolumeMeta(),
      makeSelectMaxDepositPerTransactionMeta(),
      makeSelectWithdrawalAccountCountriesMeta(),
    ],
    (
      primaryPurposeMeta,
      primaryPurposeDetailedMeta,
      plannedMonthlyDepositVolumeUSDMeta,
      plannedMonthlyWithdrawalVolumeUSDMeta,
      expectedDepositOperationsMonthlyMeta,
      expectedDailyDepositVolumeMeta,
      maxDepositPerTransactionMeta,
      withdrawalAccountCountriesMeta
    ) => ({
      accountActivity: {
        [Field.PRIMARY_PURPOSE_CORPORATE]: primaryPurposeMeta.get('source'),
        [Field.PRIMARY_PURPOSE_DETAILED_CORPORATE]: primaryPurposeDetailedMeta.get('source'),
        [Field.PLANNED_MONTHLY_DEPOSIT_VOLUME_USD]: plannedMonthlyDepositVolumeUSDMeta.get(
          'source'
        ),
        [Field.PLANNED_MONTHLY_WITHDRAWAL_VOLUME_USD]: plannedMonthlyWithdrawalVolumeUSDMeta.get(
          'source'
        ),
        [Field.EXPECTED_DEPOSIT_OPERATIONS_MONTHLY]: expectedDepositOperationsMonthlyMeta.get(
          'source'
        ),
        [Field.EXPECTED_DAILY_DEPOSIT_VOLUME]: expectedDailyDepositVolumeMeta.get('source'),
        [Field.MAX_DEPOSIT_PER_TRANSACTION]: maxDepositPerTransactionMeta.get('source'),
        [Field.WITHDRAWAL_ACCOUNT_COUNTRIES]: withdrawalAccountCountriesMeta.get('source'),
      },
    })
  );
